import React, { Component } from 'react'
import { Alert, Col, Grid } from 'react-bootstrap'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import auth from '../../../auth'
import { OPERATIONS_ADMIN, OPERATIONS_COORDINATOR, TERMINAL_ADMIN, TERMINAL_WORKER } from '../../../utils/role'
import TerminalSelect from '../../common/terminal-select'
import {
    dataReset,
    fetchData,
    unifiedTerminalsWithBackorderingActive,
} from '../../../actions/backorder-missing-parcels'
import HtmlTitle from '../../html-title'
import BackorderButton from './backorder-button'

const LONGPOLL_REFRESH_RATE_MS = 15000
const IDLE_TIMER_MS = 30000

class BackorderMissingParcelsView extends Component {
    canEditRules = auth.hasAnyRole(TERMINAL_ADMIN, TERMINAL_WORKER, OPERATIONS_ADMIN, OPERATIONS_COORDINATOR)

    constructor(props) {
        super(props)
        this.state = {
            selectedTerminal: null,
        }
    }

    componentWillUnmount = () => {
        clearInterval(this.timer)
        clearTimeout(this.idleTimer)
        document.body.removeEventListener('click', this.active)
        document.body.removeEventListener('touchstart', this.active)
    }

    componentDidMount = () => {
        document.body.addEventListener('click', this.active)
        document.body.addEventListener('touchstart', this.active)
    }

    active = () => {
        clearTimeout(this.idleTimer)
        this.idleTimer = setTimeout(this.idle, IDLE_TIMER_MS)
    }

    idle = () => {
        clearInterval(this.timer)
        this.poll(() => new Promise(this.fetchData), LONGPOLL_REFRESH_RATE_MS)
    }

    sleep = (time) =>
        new Promise((resolve) => {
            this.timer = setTimeout(resolve, time)
        })

    poll = (promiseFn, time) => {
        promiseFn().then(
            this.sleep(time).then(() => {
                this.poll(promiseFn, time)
            }),
        )
    }

    onSelectTerminal = (selectedTerminal) => {
        if (selectedTerminal) {
            const { dispatch } = this.props
            dispatch(dataReset())
            this.setState({ selectedTerminal }, this.fetchData)
        }
    }

    fetchData = () => {
        const { dispatch } = this.props
        const { selectedTerminal } = this.state
        if (selectedTerminal && unifiedTerminalsWithBackorderingActive.includes(selectedTerminal.id)) {
            return dispatch(fetchData(selectedTerminal.id))
        }
        return Promise.resolve()
    }

    renderContent = () => {
        const { backorderLoaded } = this.props
        const { selectedTerminal } = this.state
        if (selectedTerminal && !unifiedTerminalsWithBackorderingActive.includes(selectedTerminal.id)) {
            return (
                <div style={{ marginTop: '20px' }}>
                    <Alert type="info">Backordering is not supported for this terminal</Alert>
                </div>
            )
        }

        return !!selectedTerminal && !!backorderLoaded && <BackorderButton selectedTerminalId={selectedTerminal.id} />
    }

    render = () => {
        const { selectedTerminal } = this.state
        const header = (selectedTerminal && selectedTerminal.city) || 'Select Terminal'
        const isPermitted = this.canEditRules && auth.hasPermission('edit_sorting_machine')
        return (
            <div className="sorting">
                <HtmlTitle title="Backorder missing parcels" />
                <Grid>
                    <Col md={10} mdOffset={1}>
                        <h1>{header}</h1>
                        <div className="terminal-content">
                            {isPermitted ? (
                                <div>
                                    <TerminalSelect onSelect={this.onSelectTerminal} />
                                    {this.renderContent()}
                                </div>
                            ) : (
                                <div style={{ marginTop: '20px' }}>
                                    <Alert type="info">You dont have permission to backorder parcels</Alert>
                                </div>
                            )}
                        </div>
                    </Col>
                </Grid>
            </div>
        )
    }
}

BackorderMissingParcelsView.propTypes = {
    dispatch: PropTypes.func.isRequired,
    backorderLoaded: PropTypes.bool,
}

const mapStateToProps = (state) => ({
    backorderLoaded: state.backorderMissingParcels.backorderLoaded,
})

export default connect(mapStateToProps)(BackorderMissingParcelsView)
